import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container h-full" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "new-york" }, "New York", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "moscow" }, "Moscow", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Submit", -1)

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TerminalControlComponent',
  setup(__props) {

const form = ref({
  city: 'ny',
  email: 'email',
  description: 'description',
  subscribe: false,
  interval: ''
});

function submit() {
  // console.log('submitted');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submit, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event))
      }, null, 512), [
        [_vModelText, form.value.email]
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.description) = $event))
      }, null, 512), [
        [_vModelText, form.value.description]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.city) = $event))
      }, _hoisted_5, 512), [
        [_vModelSelect, form.value.city]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.subscribe) = $event))
      }, null, 512), [
        [_vModelCheckbox, form.value.subscribe]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "weekly",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.interval) = $event))
      }, null, 512), [
        [_vModelRadio, form.value.interval]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "monthly",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.interval) = $event))
      }, null, 512), [
        [_vModelRadio, form.value.interval]
      ]),
      _hoisted_6
    ], 40, _hoisted_2)
  ]))
}
}

})